<template>
  <div>
    <transition name="fade">
      <div class="row m-0 align-items-center justify-content-center loadingItem" v-if="isStoreListLoading">
        <grid-loader :loading="isStoreListLoading" :size="loaderSize"></grid-loader>
      </div>
    </transition>
    <div class="row m-0">
      <div class="col-12 category_menu my-3 px-0">
        <div class="row m-0 h-100">
          <div class="col-12 p-0 pl-md-3">
            <div class="row m-0 h-100">
              <div class="col-2 col-md-3 h-100 pt-1 pl-md-0" :class="{'bg_color': storeCategories.length > 1, 'bg_color': position != 'top'}">
                <search-menu @search="filterSearch"></search-menu>
              </div>
              <div class="col-10 col-md-9 h-100 px-0" :class="{'bg_color': storeCategories.length > 1, 'bg_color': position != 'top'}">
                <div class="row m-0 h-100">
                  <div class="col-12 h-100 pl-0">
                    <!-- <div class="row flex-row flex-nowrap h-100 overflow_x" v-if="storeCategories.length > 1">
                      <category-item v-for="cat in storeCategories" :categoryItem="cat" :key="cat.id" @selectCategory="selectCategory" :selected="categoryFilter"></category-item>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 p-0 pl-md-3">
        <!-- {{stores}} -->
        <stores-page v-for="(store, key) in appStores" :key="key" :store="store" :search="search"></stores-page>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GridLoader from 'vue-spinner/src/MoonLoader.vue'
function shuffle (a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]]
  }
  return a
}
export default {
  props: ['position'],
  components: {
    GridLoader,
    'search-menu': () => import('@/components/common/Search.vue'),
    'stores-page': () => import('@/components/landing/StoresPage.vue')
  },
  data () {
    return {
      loaderSize: '50px',
      displayList: false,
      search: '',
      categoryFilter: '',
      storeCategories: [],
      appStores: []
    }
  },
  metaInfo () {
    return {
      title: 'The Hoods - Home',
      meta: [
        { name: 'description', content: 'Shop local, online.' },
        {
          property: 'fb:app_id',
          content: '2744358572336800'
        },
        { property: 'og:title', content: 'The Hoods' },
        {
          property: 'og:description',
          content: 'Shop local, online.'
        },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:image',
          content: '/thehoods_large.png/'
        },
        {
          property: 'og:url',
          content: 'https://thehoods.app/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'stores', 'isStoreListLoading'])
  },
  created () {
    this.listenToStoreList()
  },
  watch: {
    stores () {
      this.filterStores()
    },
    search () {
      this.filterStores()
    }
  },
  methods: {
    ...mapActions(['listenToStoreList']),
    login () {
      this.$emit('login')
    },
    filterSearch (val) {
      this.search = val
    },
    selectCategory (val) {
      this.categoryFilter = val
    },
    filterStores () {
      let list = []
      console.log(this.stores)
      if (this.stores && Object.keys(this.stores).length > 0) {
        Object.values(this.stores).forEach((store) => {
          if (typeof store.details.category !== 'undefined') {
            if (store.details.nicarela && store.products && store.products.length) {
              if (this.search) {
                if (store.products.find((product) => {
                  return product.title.toLowerCase().includes(this.search.toLowerCase()) || product.description.toLowerCase().includes(this.search.toLowerCase())
                })) {
                  list.push(store)
                  if (!this.storeCategories.includes(store.details.category)) {
                    this.storeCategories.push(store.details.category)
                  }
                }
              } else {
                list.push(store)
                if (!this.storeCategories.includes(store.details.category)) {
                  this.storeCategories.push(store.details.category)
                }
              }
            }
          }
        })
      }
      this.appStores = shuffle(list)
    }
  }
}
</script>

<style>
.small_text {
  font-size: 0.8rem;
  line-height: 1;
}
.border_bottom {
  border-bottom: 1px solid var(--light-color-off);
}
.dark-mode .border_bottom {
  border-bottom: 1px solid var(--light-color-01);
}
.small_text .truncate {
    word-wrap: break-word;
    overflow-y: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 2;
  }
.small_text .form-control {
  font-size: 0.8rem;
}
.category_menu {
  height: 50px;
  position: sticky;
  top: 80px;
  z-index: 9;
}
.bg_color {
  border-top: 1px solid var(--dark-color-off);
  margin-left: -1px;
}
.dark-mode .bg_color {
  border-top: 1px solid var(--light-color-off);
  border-left: 1px solid var(--dark-color-off)
}
.overflow_x  {
  overflow-x: auto;
}

@media (min-width: 768px) {
  .category_menu {
    top: 50px;
  }
  .sidebar_cart {
    position: sticky;
    top: 120px;
    z-index: 9;
    bottom: inherit;
    width: 100%;
    max-height: calc(100vh - 120px);
  }
}
</style>
